import AutoTable from './AutoTable'
export default AutoTable



// WEBPACK FOOTER //
// ./src/components/AutoTable/index.js